<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-left">
        <div v-show="stateArrow" id="leftBox" class="leftBox" style="width: 206px">
          <vue-draggable-resizable :min-width="160" @resizing="onResize" :max-width="400" :draggable="false"
            :handles="['mr']" :w="206" :parent="false">
            <el-scrollbar>
              <tree :isSearch="isSearch" @initFun="initQuery" @nodeClick="nodeClick"></tree>
            </el-scrollbar>
          </vue-draggable-resizable>
        </div>
        <div class="leftCaret" @click="changeArrow">
          <i :class="stateArrow ? 'el-icon-caret-left' : 'el-icon-caret-right'"></i>
        </div>
      </div>
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-form">
                <el-form :inline="true" :model="formInline" class="demo-form-inline">
                  <el-form-item :label="$t('common.num')">
                    <el-select v-model="formInline.selectCarType" style="width: 120px"
                      :placeholder="$t('common.form.choseTip')" class="selectStyle">
                      <el-option v-for="item in optionsInput" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                    <el-input size="mini" v-model="formInline.selectCarValue" :placeholder="$t('common.searchTip')"
                      style="width: 150px" class="inputStyle"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('OTAManagement.typeIdStr')">
                    <el-select v-model="formInline.typeId" :placeholder="$t('common.form.choseTip')" filterable
                      size="mini" style="width: 120px">
                      <el-option v-for="item in terminalList" :key="item.id" :label="item.terminalType"
                        :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('common.terminalId')">
                    <el-input size="mini" v-model="formInline.terminalId" :placeholder="$t('common.searchTip')"
                      style="width: 150px" class="input-with-select"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('VehicleManagement.brandModel')">
                    <el-select @change="indexSelect('query')" v-model="formInline.brandId"
                      :placeholder="$t('common.brand')" filterable size="mini" style="width: 120px">
                      <el-option v-for="item in BrandList" :key="item.id" :label="item.name"
                        :value="item.id"></el-option>
                    </el-select>
                    <el-select v-model="formInline.brandTypeId" :placeholder="$t('common.model')" filterable size="mini"
                      style="width: 120px; margin-left: 5px">
                      <el-option v-for="item in typeList" :key="item.id" :label="item.name"
                        :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('VehicleManagement.forkliftType')">
                    <el-select v-model="formInline.forkliftType" :placeholder="$t('common.form.choseTip')" filterable
                      size="mini" style="width: 120px; margin-left: 5px">
                      <el-option v-for="item in forkliftTypeList" :key="item.id" :label="item.dictValue"
                        :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('VehicleManagement.deliveryTime')">
                    <el-date-picker v-model="formInline.FactoryTime" type="daterange" style="width: 220px" size="mini"
                      value-format="yyyy-MM-dd" range-separator :start-placeholder="$t('common.choseTime')"
                      end-placeholder></el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <el-button size="mini" type="primary" @click="onSearch" class="btn-chaxun">{{
                      $t("common.btn.search") }}</el-button>
                    <el-button size="mini" @click="onClear" class="btn-del">{{
                      $t("common.btn.cancel")
                    }}</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div class="rightAll-btn">
                <!-- <el-button
                  type="text"
                  :disabled="selected.length != 1"
                  @click="changeNumber()"
                  >{{ $t("VehicleManagement.btn.modifyVehicleNumber") }}</el-button
                > -->
                <el-button v-if="isPrimaryKey('VEHICLEFILES_VEHICLEPUSH')" type="text" :disabled="selected.length != 1"
                  @click="changePush">{{ $t("VehicleManagement.btn.vehiclePush") }}</el-button>
                <el-button v-if="isPrimaryKey('VEHICLEFILES_REPLACETERMINAL')" type="text"
                  :disabled="selected.length != 1" @click="changeCar">{{ $t("VehicleManagement.btn.replaceTerminal")
                  }}</el-button>
                <el-button v-if="isPrimaryKey('VEHICLEFILES_BINDTERMINAL')" type="text" :disabled="selected.length != 1"
                  @click="bindCar">{{ $t("VehicleManagement.btn.bindTerminal") }}</el-button>
                <el-button v-if="isPrimaryKey('VEHICLEFILES_VEHICLEALLOCATION')" type="text"
                  :disabled="selected.length == 0" @click="transferCar">{{
                    $t("VehicleManagement.btn.vehicleAllocation")
                  }}</el-button>
                <el-button v-if="isPrimaryKey('VEHICLEFILES_EDIT')" type="text" :disabled="selected.length != 1"
                  @click="editCar">{{ $t("common.btn.edit") }}</el-button>
                <el-button v-if="isPrimaryKey('VEHICLEFILES_DELETE')" type="text" :disabled="selected.length == 0"
                  @click="deleteCar">{{ $t("common.btn.delete") }}</el-button>
                <el-button v-if="isPrimaryKey('VEHICLEFILES_ADD')" type="text" @click="addCar">{{
                  $t("common.btn.add")
                }}</el-button>
                <el-button v-if="isPrimaryKey('VEHICLEFILES_BATCHIMPORT')" type="text" @click="BulkImport">{{
                  $t("common.btn.batchUpload")
                }}</el-button>
                <el-button v-if="isPrimaryKey('VEHICLEFILES_DOWN')" type="text" @click="downCar">{{
                  $t("common.btn.download")
                }}</el-button>
              </div>
              <i-table :list="list" :height="height" ref="carTable" @handleSelectionChange="handleSelectionChange"
                :options="option" :columns="columns" :operates="operates"></i-table>
              <IPagination ref="page" @PageFun="changeSize"></IPagination>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog width="1000px" :before-close="closeDia" class="carDialong" :title="diaTitle"
        :visible.sync="dialogFormVisible" :close-on-click-modal="false">
        <el-form :rules="rules" ref="form" :model="form">
          <div class="carTitle">
            {{ $t("VehicleManagement.basicInformation") }}
          </div>
          <el-form-item prop="carId" :label="$t('common.carId') + ':'" :label-width="formLabelWidth">
            <el-input size="small" v-model="form.carId" autocomplete="off" :disabled="disabled"></el-input>
            <!-- <el-button @click="generate">{{ $t("VehicleManagement.generate") }}</el-button> -->
          </el-form-item>
          <el-form-item prop="manufactureNum" :label="$t('common.manufactureNum') + ':'" :label-width="formLabelWidth">
            <el-input size="small" v-model="form.manufactureNum" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item prop="plateNum" :label="$t('common.plateNum') + ':'" :label-width="formLabelWidth">
            <el-input size="small" v-model="form.plateNum" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item prop="registrationCode" :label="$t('common.registrationCode') + ':'"
            :label-width="formLabelWidth">
            <el-input size="small" v-model="form.carExpiresNum" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item prop="customNum" :label="$t('common.customNum') + ':'" :label-width="formLabelWidth">
            <el-input size="small" v-model="form.customNum" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item prop="motorNum" :label="$t('VehicleManagement.engineNo') + ':'" :label-width="formLabelWidth">
            <el-input size="small" v-model="form.motorNum" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item prop="carSaveAddress" :label="$t('VehicleManagement.storageAddress') + ':'"
            :label-width="formLabelWidth">
            <el-input size="small" v-model="form.carSaveAddress" autocomplete="off" class="addressStyle"></el-input>
          </el-form-item>
          <el-form-item prop="vin" :label="$t('VehicleManagement.frameNumber') + ':'" :label-width="formLabelWidth">
            <el-input size="small" v-model="form.vin" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item prop="leaseTime" :label="$t('common.leaseTerm') + ':'"
            :label-width="formLabelWidth">
            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" type="datetime" :placeholder="$t('common.choseTime')"
              v-model="form.leaseTime"></el-date-picker>
          </el-form-item>
          <el-form-item label="报停状态:" :label-width="formLabelWidth" prop="reportState">
            <el-select v-model="form.reportState" :placeholder="$t('common.form.choseTip')" @change="changeStatus">
              <el-option label="正常" value="0"></el-option>
              <el-option label="已报停" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="form.reportState == 1" prop="reportTime" label="报停时间:"
            :label-width="formLabelWidth">
            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" type="datetime" :placeholder="$t('common.choseTime')"
              v-model="form.reportTime"></el-date-picker>
          </el-form-item>
          <div class="carTitle">
            {{ $t("VehicleManagement.vehicleModelInformation") }}
          </div>
          <el-form-item prop="brandId" :label="$t('common.brand') + ':'" :label-width="formLabelWidth">
            <el-select @change="indexSelect('add')" v-model="form.brandId" :placeholder="$t('common.form.choseTip')"
              filterable>
              <el-option v-for="item in BrandList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="brandTypeId" :label="$t('common.model') + ':'" :label-width="formLabelWidth">
            <el-select v-model="form.brandTypeId" :placeholder="$t('common.form.choseTip')" filterable>
              <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('VehicleManagement.powerType') + ':'" :label-width="formLabelWidth" prop="type">
            <el-select v-model="form.type" :placeholder="$t('common.form.choseTip')">
              <el-option :label="$t('VehicleManagement.combustionEngine')" value="0"></el-option>
              <el-option :label="$t('VehicleManagement.motor')" value="1"></el-option>
              <el-option label="铅酸电池" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="tonnageType" :label="$t('VehicleManagement.capacity') + ':'" :label-width="formLabelWidth">
            <el-select v-model="form.tonnageType" :placeholder="$t('common.form.choseTip')" filterable>
              <el-option v-for="item in tonnageTypeList" :key="item.id" :label="item.dictValue" :value="item.id"></el-option>
            </el-select>
            <!-- <el-input
              size="small"
              v-model="form.capacity"
              autocomplete="off"
            ></el-input> -->
          </el-form-item>
          <el-form-item prop="deliveryTime" :label="$t('VehicleManagement.deliveryTime') + ':'"
            :label-width="formLabelWidth">
            <el-date-picker value-format="yyyy-MM-dd" type="date" :placeholder="$t('common.choseTime')"
              v-model="form.deliveryTime"></el-date-picker>
          </el-form-item>
          <el-form-item prop="carEmissionId" :label="$t('VehicleManagement.vehicleEmissions') + ':'"
            :label-width="formLabelWidth">
            <el-select v-model="form.carEmissionId" :placeholder="$t('common.form.choseTip')" filterable>
              <el-option v-for="item in carEmissionIdList" :key="item.id" :label="item.dictValue"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="forkliftType" :label="$t('VehicleManagement.forkliftType') + ':'"
            :label-width="formLabelWidth">
            <el-select v-model="form.forkliftType" :placeholder="$t('common.form.choseTip')" filterable>
              <el-option v-for="item in forkliftTypeList" :key="item.id" :label="item.dictValue"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="useSpan" :label="$t('VehicleManagement.serviceLife') + ':'" :label-width="formLabelWidth">
            <el-input size="small" v-model="form.useSpan" autocomplete="off"></el-input>
          </el-form-item>
          <!--<el-form-item prop="remarks" :label="$t('common.remarks') + ':'" :label-width="formLabelWidth">
            <el-input size="small" v-model="form.remarks" autocomplete="off"></el-input>
          </el-form-item>-->
          <div class="carTitle">
            {{ $t("VehicleManagement.sizeInformation") }}
          </div>
          <el-form-item prop="sizeLength" :label="$t('VehicleManagement.length') + ':'" :label-width="formLabelWidth">
            <el-input size="small" v-model="form.sizeLength" autocomplete="off" class="sizeStyle"></el-input>
            <span>(mm)</span>
          </el-form-item>
          <el-form-item prop="sizeWidth" :label="$t('VehicleManagement.width') + ':'" :label-width="formLabelWidth">
            <el-input size="small" v-model="form.sizeWidth" autocomplete="off" class="sizeStyle"></el-input>
            <span>(mm)</span>
          </el-form-item>
          <el-form-item prop="sizeHeight" :label="$t('VehicleManagement.height') + ':'" :label-width="formLabelWidth">
            <el-input size="small" v-model="form.sizeHeight" autocomplete="off" class="sizeStyle"></el-input>
            <span>(mm)</span>
          </el-form-item>
          <el-form-item prop="sizeForkLength" :label="$t('VehicleManagement.forkLength') + ':'"
            :label-width="formLabelWidth">
            <el-input size="small" v-model="form.sizeForkLength" autocomplete="off" class="sizeStyle"></el-input>
            <span>(mm)</span>
          </el-form-item>
          <el-form-item prop="sizePortalNum" :label="$t('VehicleManagement.portalNum') + ':'"
            :label-width="formLabelWidth">
            <el-input size="small" v-model="form.sizePortalNum" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item prop="sizeMaxLiftHeight" :label="$t('VehicleManagement.maxLift') + ':'"
            :label-width="formLabelWidth">
            <el-input size="small" v-model="form.sizeMaxLiftHeight" autocomplete="off" class="sizeStyle"></el-input>
            <span>(mm)</span>
          </el-form-item>
          <el-form-item prop="sizeClipRange" :label="$t('VehicleManagement.clampRange') + ':'"
            :label-width="formLabelWidth">
            <el-input size="small" v-model="form.sizeClipRange" autocomplete="off"></el-input>
          </el-form-item>
          <div class="carTitle">
            {{ $t("VehicleManagement.maintenanceInformation") }}
          </div>
          <el-form-item :label="$t('VehicleManagement.isMaintain') + ':'" :label-width="formLabelWidth"
            prop="isMaintain">
            <el-select v-model="form.isMaintain" :placeholder="$t('common.form.choseTip')">
              <el-option :label="$t('VehicleManagement.deny')" value="0"></el-option>
              <el-option :label="$t('VehicleManagement.correct')" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="maintainCycle" :label="$t('VehicleManagement.serviceInterval') + ':'"
            :label-width="formLabelWidth">
            <el-input size="small" v-model="form.maintainCycle" autocomplete="off" placeholder="请输入天数"></el-input>
          </el-form-item>
          <el-form-item :label="$t('VehicleManagement.reminderCycle') + ':'" :label-width="formLabelWidth"
            prop="maintainReminder">
            <el-select v-model="form.maintainReminder" :placeholder="$t('common.form.choseTip')">
              <el-option :label="'1' + $t('HomPage.day')" value="1"></el-option>
              <el-option :label="'2' + $t('HomPage.day')" value="2"></el-option>
              <el-option :label="'3' + $t('HomPage.day')" value="3"></el-option>
              <el-option :label="'4' + $t('HomPage.day')" value="4"></el-option>
              <el-option :label="'5' + $t('HomPage.day')" value="5"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item
            prop="maintainReminder"
            :label="$t('VehicleManagement.reminderCycle') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.maintainReminder"
              autocomplete="off"
            ></el-input>
          </el-form-item> -->

          <div class="carTitle">
            {{ $t("VehicleManagement.accessoriesInformation") }}
          </div>
          <el-form-item prop="safeList" label="" :label-width="formLabelWidth">
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">{{
              $t("VehicleManagement.selectAll") }}</el-checkbox>
            <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
              <el-checkbox v-for="item in parts" :label="item.dictValue" :key="item.id">{{ item.dictValue
                }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancle('form')">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button size="small" type="primary" @click="submitForm('form')">{{
            $t("common.btn.confirm")
          }}</el-button>
        </div>
      </el-dialog>
      <el-dialog width="620px" :before-close="closeTransferDia" class="transferDialong"
        :title="$t('VehicleManagement.btn.vehicleAllocation')" :visible.sync="dialogTransferFormVisible"
        :close-on-click-modal="false">
        <el-form :rules="TransferRules" ref="TransferForm" :model="TransferForm">
          <el-form-item prop="carId" :label="$t('common.carId') + '-' + $t('VehicleManagement.belongTo') + ':'
            " :label-width="LabelWidth">
            <el-input disabled type="textarea" :rows="2" size="small" v-model="TransferForm.carId"
              autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item prop="roleId" :label="$t('VehicleManagement.targetPosition') + ':'" :label-width="LabelWidth">
            <el-scrollbar>
              <tree :isSearch="isSearch" @nodeClick="changeClick"></tree>
            </el-scrollbar>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancleTransfer('TransferForm')">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button size="small" type="primary" @click="submitTransferForm('TransferForm')">{{ $t("common.btn.confirm")
            }}</el-button>
        </div>
      </el-dialog>
      <el-dialog width="620px" :before-close="closeBindDia" class="addDialong"
        :title="$t('VehicleManagement.btn.bindTerminal')" :visible.sync="dialogBindFormVisible"
        :close-on-click-modal="false">
        <el-form :rules="BindRules" ref="BindForm" :model="BindForm">
          <el-form-item prop="carId" :label="$t('common.carId') + ':'" :label-width="LabelWidth" class="form-btn">
            <el-input size="small" disabled v-model="BindForm.carId" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item prop="terminalId" :label="$t('VehicleManagement.mainTerminalId') + ':'"
            :label-width="LabelWidth" class="form-btn">
            <el-input size="small" v-model="BindForm.terminalId" autocomplete="off"></el-input>
            <el-button v-if="isShow" @click="Relieve(0)">{{
              $t("common.btn.unBind")
            }}</el-button>
          </el-form-item>
          <el-form-item prop="assistantTerminalId" :label="$t('VehicleManagement.subTerminalId') + ':'"
            :label-width="LabelWidth" class="form-btn">
            <el-input size="small" v-model="BindForm.assistantTerminalId" autocomplete="off"></el-input>
            <el-button v-if="isShows" @click="Relieve(2)">{{
              $t("common.btn.unBind")
            }}</el-button>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancleBind('BindForm')">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button size="small" type="primary" @click="submitBindForm('BindForm')">{{ $t("common.btn.bind")
            }}</el-button>
        </div>
      </el-dialog>
      <el-dialog width="620px" :before-close="closeChangeDia" class="addDialong"
        :title="$t('VehicleManagement.btn.replaceTerminal')" :visible.sync="dialogChangeFormVisible"
        :close-on-click-modal="false">
        <el-form :rules="ChangeRules" ref="ChangeForm" :model="ChangeForm">
          <el-form-item prop="terminalId" :label="$t('VehicleManagement.mainTerminalId') + ':'"
            :label-width="LabelWidth" class="form-btn">
            <el-input size="small" disabled v-model="ChangeForm.terminalId" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item prop="newTerminalId" :label="$t('VehicleManagement.newMainTerminalId') + ':'"
            :label-width="LabelWidth" class="form-btn">
            <el-input size="small" v-model="ChangeForm.newTerminalId" autocomplete="off"></el-input>
            <el-button v-if="isShow" @click="isTrue(0)">{{
              $t("common.btn.replace")
            }}</el-button>
          </el-form-item>
          <el-form-item prop="assistantTerminalId" :label="$t('VehicleManagement.subTerminalId') + ':'"
            :label-width="LabelWidth" class="form-btn">
            <el-input size="small" v-model="ChangeForm.assistantTerminalId" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item prop="newAssistantTerminalId" :label="$t('VehicleManagement.SubTerminalId') + ':'"
            :label-width="LabelWidth" class="form-btn">
            <el-input size="small" v-model="ChangeForm.newAssistantTerminalId" autocomplete="off"></el-input>
            <el-button v-if="isShow" @click="isTrue(1)">{{
              $t("common.btn.replace")
            }}</el-button>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancleChange('ChangeForm')">{{
            $t("common.btn.cancel")
          }}</el-button>
          <!-- <el-button size="small" type="primary" @click="isTrue()">{{
            $t("common.btn.replace")
          }}</el-button> -->
        </div>
      </el-dialog>
      <!-- <el-dialog
        width="620px"
        :before-close="closeCarDia"
        class="addDialong"
        :title="$t('VehicleManagement.btn.modifyVehicleNumber')"
        :visible.sync="dialogCarFormVisible"
        :close-on-click-modal="false"
      >
        <el-form
          :rules="ChangeCarRules"
          ref="ChangeCarForm"
          :model="ChangeCarForm"
        >
          <el-form-item
            prop="carId"
            :label="$t('VehicleManagement.originalVehicleNumber') + ':'"
            :label-width="LabelWidth"
          >
            <el-input
              size="small"
              disabled
              v-model="ChangeCarForm.carId"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="newCarId"
            :label="$t('VehicleManagement.newVehicleNumber') + ':'"
            :label-width="LabelWidth"
          >
            <el-input
              size="small"
              v-model="ChangeCarForm.newCarId"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancleCarChange('ChangeCarForm')"
            >{{ $t("common.btn.cancel") }}</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="submitCarForm('ChangeCarForm')"
            >{{ $t("common.btn.confirm") }}</el-button
          >
        </div>
      </el-dialog> -->
      <el-dialog width="620px" :before-close="closeBatchDia" :title="$t('common.btn.batchUpload')"
        :visible.sync="dialogBatchFormVisible" class="batchDialong" :close-on-click-modal="false">
        <div class="right-file">
          <el-button type="text" size="mini" @click="TemplateFile()">{{
            $t("common.btn.downloadModelFile")
          }}</el-button>
        </div>
        <div class="upload-file">
          <img src="../../../assets/images/upload.png" />
          <div>{{ $t("common.btn.clickUploadFile") }}</div>
          <input @change="uploadCar()" id="uploadDom" type="file" />
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogBatchFormVisible = false" class="btn-del">{{
            $t("common.btn.cancel")
          }}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import VehicleFiles from "./VehicleFiles.js";
export default VehicleFiles;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
</style>
